import { css } from "lit";

export const styles = css`
  .slide {
    --slide-default-width: 960px;
    --slide-default-height: 540px;
    --slide-accent-color: var(--theme-artwork-primary-color, #104366);
    --slide-secondary-color: var(--theme-artwork-secondary-color, #e24213);
    --background-red: var(--slide-background-red, 255);
    --background-blue: var(--slide-background-blue, 255);
    --background-green: var(--slide-background-green, 255);
    --slide-current-height: var(--slide-default-height);
    width: var(--slide-default-width);
    height: var(--slide-current-height);
    display: block;
    position: relative;
  }

  .mobile,
  .mobile-tall {
    --font-size-2xs: 14px;
    --font-size-xs: 16px;
    --font-size-sm: 18px;
    --font-size-md: 20px;
    --font-size-lg: 22px;
    --font-size-xl: 24px;
    --font-size-2xl: 28px;
    --font-size-3xl: 32px;
    --font-size-4xl: 36px;
    --font-size-5xl: 40px;
    --font-size-6xl: 44px;
    --font-size-7xl: 48px;
    --font-size-8xl: 52px;
    --font-size-9xl: 56px;
    --font-size-10xl: 60px;
  }

  .tall,
  .mobile-tall {
    --slide-current-height: 100%;
  }
`;
